<template>
  <div class="w12 side-coin">
    <div class="w12 padding-content mp12">
      <div class="assets-new">
        <div class="w12" flex fie nowrap>
          <div class="user-information">
            <img
              v-if="user.level > 0"
              width="40px"
              :src="
                require(`../../../assets/img/grade/ic_grade_${
                  user.level > 6 ? $level(7).type : $level(user.level).type
                }.png`)
              "
              alt=""
            />
            <div class="user-level">
              <b class="name">{{ user.name }}</b
              >{{ $t("mypage.asset.님의 회원등급") }}
              <b>{{
                user.level > 6 ? $level(7).title : $level(user.level).title
              }}</b>
            </div>
          </div>
        </div>
        <div class="asset total" flex fjb>
          <div class="bold W6">{{ $t("mypage.asset.총 자산") }}</div>
          <div class="bold W6 text-right">
            {{ totalAssetToKRW | formatNumber }} KRW
          </div>
        </div>
        <div class="asset" flex fjb>
          <div class="bold w6">{{ $t("mypage.asset.사용가능") }}</div>
          <div class="w6 text-right">
            {{ totalAvailToKRW | formatNumber }} KRW
          </div>
        </div>
      </div>

      <div class="search-box">
        <input
          type="text"
          maxlength="10"
          v-model="searchText"
          :placeholder="$t('mypage.asset.코인명/심볼명 검색')"
        />
        <i class="el-icon-search search-icon"></i>
      </div>
      <div class="divide-wrap">
        <div class="toggle-box" flex>
          <el-switch
            class="mypage have-asset"
            v-model="haveCoin"
            :active-text="$t('mypage.asset.보유자산만')"
          />
        </div>
        <div v-show="haveCoin" class="smallballance-type01 check-box">
          <el-checkbox :value="getSmallBalance" @change="setSmallBalance">{{
            $t("mypage.asset.소액자산숨기기")
          }}</el-checkbox>
          <div
            class="tooltip"
            @mouseover="tooltipShow = true"
            @mouseleave="tooltipShow = false"
          >
            <div class="hidden-box" :class="{ show: tooltipShow }">
              <div class="background-box">{{ $t("mypage.asset.숨기기") }}</div>
              <div class="triangle-box"></div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="w12 mt10">
      <router-link
        :to="`/balances/deposit/${asset.code}`"
        tag="div"
        class="my-asset"
        v-for="(asset, index) in filterWallet"
        :key="index"
        flex
        fic
      >
        <div class="list-item w6">
          <div v-if="user.meta.banWithdrawal === 'Y'" class="asset-name">
            <span class="name" v-html="filterSearch(asset.name)"></span>
            <span class="asset" v-html="filterSearch(asset.code)"></span>
            <span v-if="asset.ioInEnable == 'N'" class="obstruct-icon">
              <img src="@/assets/img/trade/ic_warning.svg" alt />
            </span>
            <span v-else class="obstruct-icon">
              <img src="@/assets/img/trade/ic_nowithdrawal.svg" alt />
            </span>
          </div>
          <div v-else class="asset-name">
            <span class="name" v-html="filterSearch(asset.name)"></span>
            <span class="asset" v-html="filterSearch(asset.code)"></span>
            <span
              v-if="asset.ioInEnable == 'N' && asset.ioOutEnable == 'N'"
              class="obstruct-icon"
            >
              <img src="@/assets/img/trade/ic_warning.svg" alt />
            </span>
            <span v-else-if="asset.ioInEnable == 'N'" class="obstruct-icon">
              <img src="@/assets/img/trade/ic_nodeposit.svg" alt />
            </span>
            <span v-else-if="asset.ioOutEnable == 'N'" class="obstruct-icon">
              <img src="@/assets/img/trade/ic_nowithdrawal.svg" alt />
            </span>
          </div>
        </div>
        <div class="amount w6 text-right">
          <span v-if="asset.code == 'KRW'">
            {{ parseInt(asset.amount) | formatNumber(0) }}
          </span>
          <span v-else>
            {{ asset.amount | formatNumber(8) }}
          </span>
          <span>{{ asset.code }}</span>
        </div>

        <div class="w12 to-krw" flex fje v-if="toKRW(asset.code).isShow">
          ≒ {{ asset.tokrw | formatNumber4 }} KRW
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState, mapMutations } from "vuex";
import Decimal from "decimal.js";
import Api from "@/common/Api";

export default {
  data() {
    return {
      smallBallance: false,
      tooltipShow: false,
    };
  },
  computed: {
    ...mapState(["Server"]),
    ...mapGetters({
      totalAssetToKRW: "totalAssetToKRW",
      totalAvailToKRW: "totalAvailToKRW",
      user: "userInfo",
      // authLevel: "authLevel",
      wallet: "wallet",
      walletByCoinName: "walletByCoinName",
      // coinSettings: "coinSettings",
      // getCoinById: "getCoinById",
      // marketsByBaseCoinCode: "marketsByBaseCoinCode",
      // marketsByCode: "marketsByCode",
      // pend: "pend",
      // authStepLevel: "authStepLevel",
      // worldCurrencyByCoinCode: "worldCurrencyByCoinCode",
      toKRW: "toKRW",
      // currencySettings: "currencySettings",
      getSmallBalance: "getSmallBalance",
    }),
    searchText: {
      get() {
        return this.$store.state.User.assetSearchText;
      },
      set(value) {
        this.$store.commit("updateAssetSearchText", value);
      },
    },
    haveCoin: {
      get() {
        return this.$store.state.User.assetHaveCoinToggle;
      },
      set(value) {
        this.$store.commit("updateAssetHaveCoinToggle", value);
      },
    },
    // totalWallet() {
    //   return (
    //     this.stateWallet("total") + (this.walletByCoinName("KRW").total || 0)
    //   );
    // },
    // availableWallet() {
    //   return (
    //     this.stateWallet("available") +
    //     (this.walletByCoinName("KRW").available || 0)
    //   );
    // },
    userWallets() {
      return _.map(this.$store.state.Market.coin, (coin) => {
        let wallet = this.wallet[coin.id];
        if (!wallet) {
          wallet = { total: 0 };
        }
        const data = {
          ...wallet,
          ...coin,
          name: coin.name,
          img: `//static.flybit.com/static/img/mobile/coin_${coin.code}.png`,
          amount: wallet.total,
          coin: coin.coin,
          tokrw: new Decimal(this.toKRW(coin.code).price)
            .mul(wallet.total)
            .toNumber(),
          available: coin.available,
          code: coin.code,
          active: coin.enable === "Y",
          availMarkets: (code) => {
            const availMarkets = _.get(
              this.marketsByDealCoin,
              coin.code,
              []
            ).map((market) => market.baseCoinCode);
            return availMarkets.includes(code);
          },
        };

        return data;
      });
    },
    filterWallet() {
      let filterWallet = this.userWallets.filter((asset) => {
        if (
          asset.name.indexOf(this.searchText) == -1 &&
          asset.code.indexOf(this.searchText.toUpperCase()) == -1
        )
          return false;
        else return true;
      });

      if (this.haveCoin) {
        filterWallet = filterWallet.filter((asset) => {
          if (asset.amount && asset.amount != 0) return true;
          else return false;
        });
      }

      const btcIndex = filterWallet.findIndex((asset) => asset.code == "BTC");
      if (btcIndex != -1) {
        const btc = filterWallet[btcIndex];
        filterWallet.splice(btcIndex, 1);
        filterWallet.unshift(btc);
      }

      const usdtIndex = filterWallet.findIndex((asset) => asset.code == "USDT");
      if (usdtIndex != -1) {
        const usdt = filterWallet[usdtIndex];
        filterWallet.splice(usdtIndex, 1);
        filterWallet.unshift(usdt);
      }

      const wonIndex = filterWallet.findIndex((asset) => asset.code == "KRW");
      if (wonIndex != -1) {
        const won = filterWallet[wonIndex];
        filterWallet.splice(wonIndex, 1);
        filterWallet.unshift(won);
      }

      //소액자산
      if (this.haveCoin == true) {
        if (this.getSmallBalance == true) {
          filterWallet = _.filter(filterWallet, (asset) => {
            if (asset.code == "KRW") {
              return asset.amount > 1000;
            } else {
              return asset.tokrw > 1000;
            }
          });
        }
      } else {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.$store.commit("setSmallBalance", false);
      }
      return filterWallet;
    },
  },
  methods: {
    ...mapMutations(["setSmallBalance"]),
    // stateWallet(state) {
    //   try {
    //     return _.reduce(
    //       this.coinSettings,
    //       (sum, coin) => {
    //         console.log('coin.code');
    //         console.log(coin.code);
    //         const price =
    //           this.toKRW(this.$bnCode(coin.code)).price *
    //           this.walletByCoinName(coin.code)[state];
    //         const typeChx = typeof price !== "number" || !price ? 0 : price;
    //         return sum + typeChx;
    //       },
    //       0
    //     );
    //   } catch (e) {
    //     return 0;
    //   }
    // },
    filterSearch(name) {
      return name.replace(
        this.searchText.toUpperCase(),
        `<b class='c-main'>${this.searchText.toUpperCase()}</b>`
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.obstruct-icon {
  img {
    // margin-top: 3px;
  }
}
.divide-wrap {
  display: flex;
  justify-content: space-between;
  margin-top: 17px;
  .check-box {
    position: relative;
    display: flex;
    justify-content: flex-end;
    .tooltip {
      background-image: url("../../../assets/img/mypage/question-gray.svg");
      background-repeat: no-repeat;
      background-position: center;
      width: 14px;
      height: 18px;
      margin-left: 4px;
      &:hover {
        background-image: url("../../../assets/img/mypage/question-black.svg");
        background-repeat: no-repeat;
        background-position: center;
        width: 14px;
        height: 18px;
      }
    }
    .hidden-box {
      display: none;
      position: absolute;
      bottom: -9px;
      right: 0;
      width: 14px;
      height: 14px;
      padding: 12px;
      font-size: 11px;
      color: #fff;
      z-index: 1000;
      &.show {
        display: block;
      }
      .background-box {
        position: absolute;
        top: 21px;
        right: 7px;
        width: 154px;
        padding: 8px 12px;
        border-radius: 3px 0 3px 3px;
        background-color: rgba(0, 0, 0, 0.8);
      }
      .triangle-box {
        position: absolute;
        top: 15px;
        right: 7px;
        width: 0px;
        height: 0px;
        border-top: 6px solid transparent;
        border-right: 8px solid rgba(0, 0, 0, 0.8);
      }
    }
  }
}
.text-right {
  text-align: right;
}
</style>
